import { Spinner } from "../../components/spinner/Spinner";
import { IconButton } from "../../components/IconButton/IconButton";
import { getAPIClient } from "../../apiClient";
import { fetchRecordsUntilUpdated } from "../../utils/polling";
import React, { useEffect } from "react";
import { useAtom } from "jotai";
import { refreshingAtom } from "../../jotai/atoms";
import { ImageIcon } from "../ImageIcon";

export default function RefreshButton() {
  const [refreshing, setRefreshing] = useAtom(refreshingAtom);

  const refreshRecords = async () => {
    setRefreshing(true);
    await getAPIClient().refreshRecords();
    /**
     * Do not await this so that when we refresh we don't show a loading squirrel for the entire time it takes for the
     * backend to refresh all records from the IIS.
     */
    fetchRecordsUntilUpdated();
    // Give the sense of loading doing something a bit more than firing off an API call
    await new Promise((resolve) => setTimeout(resolve, 1000));
    setRefreshing(false);
  };

  return (
    <>
      <button
        className="btn btn-primary btn-ghost text-primary-content"
        onClick={() => refreshRecords()}
        disabled={refreshing}
      >
        <ImageIcon
          src="/assets/images/Icon_Refresh_White.png"
          className={refreshing ? "animate-spin" : ""}
        />
      </button>
    </>
  );
}
